<template>
    <div>
        <header class="header-section">
            <div class="container-custom">
                <div class="row">
                    <div class="col-padding col-xs-6">
                        <img src="./assets/images/logo.png" alt="" class="img-max-width">
                    </div>
                    <div class="col-padding col-xs-6 text-right">
                        <p class="c-gold s18 m0">ZADZWOŃ DO NAS</p>
                        <p class="section-number c-black2 s28 f-myriadProBold">
                            <a class="contact-link-black" href="tel:603-588-575">+48 603 588 575</a>
                        </p>
                    </div>
                </div>
            </div>
        </header>
        <section class="main-section _whatWeDo" v-observe-visibility="wwdSectionVChanged">
            <div class="container-custom -section-bg">
                <div class="row">
                    <div class="-section-col col-xs-7 col-padding">
                        <div class="section-mainInfo-block _onWhite">
                            <h2 class="block-title">{{ wwHeader.main }}</h2>
                            <p class="block-text">
                                Programowanie to nasza pasja. Od kilkunastu lat budujemy dedykowane rozwiązania oparte o
                                procesory sygnałowe.
                                Specjalizujemy się w algorytmach przetwarzania obrazów oraz analizie danych w czasie
                                rzeczywistym.
                                <br><br>
                                W naszej pracy staramy się łączyć najnowsze technologie z prostotą dnia codziennego.
                                Dzięki temu jesteśmy w stanie budować zaawansowane produkty, które idealnie współgrają z
                                otaczającym nas światem.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="main-section _realizationSolution" v-observe-visibility="dsSectionVChanged">
            <div class="container-custom -section-bg">
                <div class="row">
                    <div class="-section-col col-xs-7 col-padding">
                        <div class="section-mainInfo-block _onGreen">
                            <h2 class="block-title">{{ dsHeader.main }}</h2>
                            <h3 class="block-underTitle">opartych o procesory sygnałowe</h3>
                            <p class="block-text">
                                W ciągu naszej kilkunastoletniej praktyki nigdy nie korzystaliśmy z półśrodków! Budujemy nasze rozwiązania wykorzystując tylko najlepsze komponenty.
                                Przy projektowaniu systemów opartych o procesy sygnałowe, współpracujemy z takimi firmami jak Texas Instruments® czy Altera®.
                                <br><br>
                                Moc obliczeniową staramy się zawsze dopasować do postawionego zadania.
                                Dzięki połączeniu najnowszych technologii jesteśmy w stanie zagwarantować maksymalną wydajność i bezpieczeństwo budowanych systemów.
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="nothingImpossible-section">
            <div class="container-custom">
                <div class="row">
                    <div class="col-padding">
                        <h2 class="text-center text-uppercase  s56 m-t-70 m-b-80">
                            Nie ma dla nas <br>
                            rzeczy <span class="s68 w700 f-myriadProBold" v-observe-visibility="imSectionVChanged">{{ imHeader.main }}</span>
                        </h2>
                    </div>
                </div>
                <div class="row">
                    <div class="table-container">
                        <div class="-section-col table-col _middle col-xs-5 col-padding">
                            <img src="./assets/images/cpu-iso2.png" alt="" class="img-max-width">
                        </div>
                        <div class="-section-col table-col _middle col-xs-7 col-padding">
                            <div class="section-mainInfo-block">
                                <h2 class="block-title">DSP</h2>
                                <p class="block-text">
                                    Skorzystaj z naszego doświadczenia w budowie zaawansowanych systemów! Dzięki wykorzystaniu procesorów sygnałowe do realizacji
                                    algorytmów przetwarzania danych jesteśmy w stanie diametralnie przyspieszyć Twoje środowisko pracy.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="table-container">
                        <div class="-section-col table-col _middle col-xs-7 col-padding">
                            <div class="section-mainInfo-block">
                                <h2 class="block-title">FPGA</h2>
                                <p class="block-text">
                                    Nasze produkty w dużej mierze opieramy o programowalne struktury logiczne (FPGA), w
                                    których realizowane są równoległe algorytmy obróbki sygnałów oraz obrazów pochodzących z czujników radarowych,
                                    kamer termowizyjnych (IR) czy dziennych (TV).
                                </p>
                            </div>
                        </div>
                        <div class="-section-col table-col _middle col-xs-5 text-right col-padding">
                            <img src="./assets/images/laptop-iso.png" alt="" class="img-max-width">
                        </div>
                    </div>
                </div>
                <div class="row m-b-60">
                    <div class="table-container">
                        <div class="-section-col table-col _middle col-xs-5 col-padding">
                            <img src="./assets/images/card-iso.png" alt="" class="img-max-width">
                        </div>
                        <div class="-section-col table-col _middle col-xs-7 col-padding">
                            <div class="section-mainInfo-block">
                                <h2 class="block-title">ARM</h2>
                                <p class="block-text">
                                    Świat urządzeń <i>embedded</i> również nie ma przed nami tajemnic!
                                    Wykorzystujemy najnowsze rozwiązania procesorów z rodziny ARM. W połączeniu z RTOS Linux udostępniając tym samym w pełni otwartą architekturę programo-sprzętową.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="individualSolutions-section">
            <div class="container-custom -section-bg">
                <div class="row">
                    <div class="col-padding">
                        <h2 class="text-center text-uppercase s56 c-white m-t-0 m-b-20">
                            Rozwiązania dopasowane<br>
                            do <span class="s68 w700 f-myriadProBold" v-observe-visibility="hardSectionVChanged">{{ hardHeader.main }}</span> założeń
                        </h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-padding">
                        <p class="section-text text-center">

                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="clientOurPan-section">
            <div class="container-custom -section-bg">
                <div class="row">
                    <div class="table-container">
                        <div class="-section-col table-col _middle col-xs-5">
                            <img src="./assets/images/throne.png" alt="" class="img-max-width">
                        </div>
                        <div class="-section-col table-col _middle col-xs-7 col-padding">
                            <div class="section-mainInfo-block">
                                <div class="block-title">
                                    <div class="display-table">
                                        <div class="display-table-cell _middle"
                                             style="font-size: 130px;line-height: 98px;padding-right:10px;">
                                            Nasz
                                        </div>
                                        <div class="display-table-cell _middle" style="line-height: 51px;">
                                            klient <br>
                                            Pan
                                        </div>
                                    </div>
                                </div>
                                <p class="block-text">
                                    Opowiedz nam o swoim problemie, a my dołożymy wszelkich starań, aby jego rozwiązanie
                                    było dla Ciebie w pełni satysfakcjonujące.
                                    <br><br>
                                    Nie boimy się wyzwań! Maksymalnie funkcjonalne, spełniające wszystkie wymagania, a
                                    zarazem zaawansowane technologicznie -
                                    właśnie tak określane są nasze produkty przez naszych Klientów.
                                    <br><br>
                                    Dołącz do nich już dziś!
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="trustUs-section">

			<div class="container-custom -section-bg">
				<div class="row" style="disply=none">
                    <hr>
					<div class="col-padding">
						<h2 class="text-uppercase s56 m-t-0 m-b-20">
						<b>Oni nam <span class="s68 w700 f-myriadProBold">zaufali</span></b>
						</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-padding">
						<div class="section-table display-table">
							<div class="display-table-row">
								<div class="section-table-cell display-table-cell">
									<div class="section-item">
										<a target="blank" href="https://www.pctechnologies.net/"><img src="./assets/images/trusted/pctechnologies.png" alt=""/></a>
									</div>
								</div>
								<div class="section-table-cell display-table-cell">
									<div class="section-item">
										<a target="blank" href="http://www.wze.com.pl/"><img src="./assets/images/trusted/wze-zielonka.jpg" alt=""/></a>
									</div>
								</div>
								<div class="section-table-cell display-table-cell">
									<div class="section-item">
										<a target="blank" href="http://www.kontron.com/"><img src="./assets/images/trusted/kontron.png" alt=""/></a>
									</div>
								</div>
							</div>
							<div class="display-table-row">
								<div class="section-table-cell display-table-cell">
									<div class="section-item">
										<a target="blank" href="http://www.prexer.com.pl/"><img src="./assets/images/trusted/prexer.png" alt=""/></a>
									</div>
								</div>
								<div class="section-table-cell display-table-cell">
									<div class="section-item">
										<a target="blank" href="http://www.pitradwar.com/"><img src="./assets/images/trusted/pitradwar.png" alt=""/></a>
									</div>
								</div>
								<div class="section-table-cell display-table-cell">
									<div class="section-item">
										<a target="blank" href="http://www.wat.edu.pl/"><img src="./assets/images/trusted/wat.jpg" alt=""/></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        <section class="contact-section">
            <div class="container-custom -section-bg">
                <div class="row">
                    <div class="col-padding">
                        <h2 class="section-title" v-observe-visibility="contactSectionVChanged">{{ contactHeader.main }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="-section-col col-xs-4 col-padding">
                        <div class="section-mainInfo-block">
                            <h4 class="block-title">Adres</h4>
                            <p class="block-text">
                                ul. Jana Olbrachta 124/51<br>
                                01-373, Warszawa
                            </p>
                            <h4 class="block-title">Kontakt</h4>
                            <p class="block-text">
                                <a class="contact-link-white" href="mailto:wiwtechdsp@op.pl">e-mail:
                                    wiwtechdsp@op.pl</a><br>
                                <a class="contact-link-white" href="tel:603-588-575">tel. 603-588-575</a>
                            </p>
                            <h4 class="block-title">Dane firmy</h4>
                            <p class="block-text">
                                WIW TECHDSP Sp. z o. o.<br>
                                REGON: 368311947<br>
                                NIP: 522-310-05-92
                            </p>

                        </div>
                    </div>
                    <terminal-component/>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import TerminalComponent from './components/Terminal.vue'

    export default {
        data() {
            return {
                wwHeader: {
                    main: '000000000 0000000 000 0 000000000',
                    result: 'PERFEKCJA OBJAWIA SIĘ W PROSTOCIE'.split(''),
                    wasAnimated: false
                },
                dsHeader: {
                    main: '000000000 000000000000 000000000',
                    result: 'REALIZACJA DEDYKOWANYCH ROZWIĄZAŃ'.split(''),
                    wasAnimated: false
                },
                imHeader: {
                    main: '000000000000',
                    result: 'NIEMOŻLIWYCH'.split(''),
                    wasAnimated: false
                },
                hardHeader: {
                    main: '0000000000000000',
                    result: 'NAJTRUDNIEJSZYCH'.split(''),
                    wasAnimated: false
                },
                contactHeader: {
                    main: '000000',
                    result: 'KONTAKT'.split(''),
                    wasAnimated: false
                }
            }
        },
        components: {
            TerminalComponent
        },
        methods: {
            animate: function (animTextObj, isVisible, interval) {

                if (!animTextObj.wasAnimated && isVisible) {
                    animTextObj.wasAnimated = true;

                    var fullTextRandArr = [];
                    for (var i = 0; i < animTextObj.result.length; ++i)
                        fullTextRandArr.push(Math.floor(Math.random() * 3) + 2);

                    var textArr = animTextObj.main.split('');
                    var i = 0;

                    var interval = setInterval(function () {
                        if (animTextObj.result[i] != ' ' && fullTextRandArr[i] != 0) {
                            textArr[i] = Math.round(Math.random());
                            fullTextRandArr[i] -= 1;
                        } else {
                            textArr[i] = animTextObj.result[i];
                            if (animTextObj.main.trim() == animTextObj.result.join('')) {
                                clearInterval(interval);
                            }
                        }
                        animTextObj.main = textArr.join('');
                        ++i;
                        i %= fullTextRandArr.length;
                    }, interval);
                }
            },
            wwdSectionVChanged: function (isVisible, entry) {
                this.animate(this.wwHeader, isVisible, 10);
            },
            dsSectionVChanged: function (isVisible, entry) {
                this.animate(this.dsHeader, isVisible, 10);
            },
            imSectionVChanged: function (isVisible, entry) {
                this.animate(this.imHeader, isVisible, 20);
            },
            hardSectionVChanged: function (isVisible, entry) {
                this.animate(this.hardHeader, isVisible, 20);
            },
            contactSectionVChanged: function (isVisible, entry) {
                this.animate(this.contactHeader, isVisible, 20);
            }
        }
    }

</script>

<style>
    @import url(./assets/css/main.css)

</style>



// WEBPACK FOOTER //
// App.vue?5116da81